// src/services/authService.js
import axiosInstance from '../utils/axiosInstance';
import authHttp from "@/utils/authHttp";
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

const REFRESH_KEY = "mobile_refresh_token";

export async function login(credentials) {
    const { data } = await authHttp.post(`/auth/login`, credentials);
    return data;
}

export async function verifyOtpService(payload) {
  const { data } = await axiosInstance.post("/auth/verify-otp", payload);
  return data;
}

export async function generateOTP(employeeId) {
    const { data } = await axiosInstance.post(`/auth/generate-otp`, {
        employee_id: employeeId,
    });
    return data;
}

export async function logout() {
    try {
        await authHttp.post(`/auth/logout`);
    } catch { }
}

export async function getMe() {
    const { data } = await axiosInstance.get(`/auth/me`);
    return Array.isArray(data) ? data : data?.data ?? [];
}

export function setAuthHeader(token) {
    if (token) {
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete axiosInstance.defaults.headers.common['Authorization'];
    }
}

export async function verifyInvitationLink(token) {
    const { data } = await axiosInstance.get(`/auth/verify/${token}`);
    return data;
}

export async function acceptInvitation(token, password) {
    const { data } = await axiosInstance.post(`/auth/accept`, { token, password });
    return data;
}

// Why a resent code is needed — decides the wording of the OTP email.
// Must match OTP_PURPOSES in the backend's utils/otpEmail.js.
export const OTP_PURPOSE = {
    LOGIN_VERIFICATION: "login_verification",
    PASSWORD_RESET: "password_reset",
};

export async function resendOTP(email, purpose) {
    const { data } = await axiosInstance.post(`/auth/resendOTP`, {email, purpose});
    return data;
}

export async function forgotPasswordRequest(email) {
    const { data } = await axiosInstance.post(`/auth/forgotPassword`, {email});
    return data;
}

// resetToken comes from verifying the forgot-password OTP (verifyOtpService).
export async function resetPasswordRequest(id, password, resetToken) {
    const { data } = await axiosInstance.post(`/auth/resetPassword/${id}`, {password, resetToken});
    return data;
}

export async function refresh() {
    const isMobile = Capacitor.getPlatform() !== "web";

    if (!isMobile) {
        const { data } = await authHttp.get("/auth/refresh"); // cookie
        return data;
    }

    const { value } = await Preferences.get({ key: REFRESH_KEY });
    console.log(value)
    if (!value) {
        // force session expired
        throw new Error("No mobile refresh token");
    }

    const { data } = await authHttp.get(
        "/auth/refresh",
        {
            headers: {
                Authorization: `Bearer ${value}`, // header optional if you're using body
            },
        }
    );

    return data;
}

export async function sendenQuiry(payload) {
    const { data } = await axiosInstance.post(`/auth/sendenQuiry`, payload);
    return data;
}

export async function verifyEmployeeInvite(token) {
    const { data } = await axiosInstance.get(`/auth/employee/verify/${token}`);
    return data;
}

export async function acceptEmployeeInvite(token, password) {
    const { data } = await axiosInstance.post(`/auth/employee/accept-invite`, { token, password });
    return data;
}

export async function fetchCompanyRoles() {
    const { data } = await axiosInstance.get(`/auth/access-roles`);
    return data;
}

export async function acceptAdminInvite(token, password) {
    const { data } = await axiosInstance.post(`/auth/accept-access-role-invite`, { token, password });
    return data;
}